import React, { useState, useEffect } from "react";
import Axios from "axios";
import { baseUrl } from "../../config";
import FormOriginal from "./form";
import { Redirect } from "react-router-dom";
import { useAlert } from "react-alert";

function Edit(props) {
  const [response, setResponse] = useState();
  const [edited, setEdited] = useState(false);
  const alert = useAlert();
  useEffect(() => {
    Axios.get(baseUrl + "order/" + props.match.params.id)
      .then((response) => {
        setResponse(response.data);
      })
      .catch(function (error) {});

    return () => setEdited(false);
  }, []);
  const handleSubmit = (e, form) => {
    e.preventDefault();
    form.validateFields((err, values) => {
      if (!err) {
        Axios.put(baseUrl + "order/cargo/" + props.match.params.id, {
          cargoCompany: values.cargoCompany,
          cargoStatus: "kargoyaverildi",
          trackNumber: values.trackNumber,
        }).then((response) => setEdited(true));
      }
    });
  };
  if (edited) {
    alert.success("Kargo Durumu Basariyla Guncellendi!");
    return <Redirect to="/orders/list"></Redirect>;
  }
  if (!response) {
    return <div>Loading</div>;
  }

  return (
    <FormOriginal
      defaultValues={response}
      handleSubmit={handleSubmit}
      type="Edit"
    />
  );
}

export default Edit;
